var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "updateFileForm",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return (() => {}).apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "1200",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "mb-10" },
                    [
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.data.title
                              ? `${_vm.data.title} файл`
                              : `Создать файл`
                          )
                        ),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            link: "",
                            small: "",
                            outlined: "",
                            color: "primary",
                            to: {
                              name: "page-media-library",
                            },
                            loading: _vm.loading,
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "PageContent",
                        { attrs: { height: "85" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                { attrs: { justify: "space-between" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Название *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "name",
                                              autofocus: "",
                                              outlined: "",
                                              "error-messages":
                                                _vm.validationErrors.name,
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "name",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "fields.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              autofocus: "",
                                              outlined: "",
                                              readonly: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                              value: _vm.fields.fileName,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v("Оригинальное имя"),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value:
                                                _vm.fields.originalFileName,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Тип")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value: _vm.fields.type,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Ширина")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value: _vm.fields.width,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Высота")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value: _vm.fields.height,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Формат")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value: _vm.fields.format,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Размер")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: "",
                                              loading: _vm.loading,
                                              value: _vm.fields.size,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v("Альтернативный текст ("),
                                              _c("TranslationIcon"),
                                              _vm._v(")"),
                                            ],
                                            1
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.loading,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.altText,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "altText",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "fields.altText",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("MediaFilePicker", {
                                            attrs: {
                                              "is-reversed": "",
                                              "payload-only": "",
                                              "return-file-only": "",
                                              "hide-delete": "",
                                              label: "",
                                              "button-name": "Заменить...",
                                              multiple: false,
                                              "file-type":
                                                _vm.$options.mediaTypesByKeys[
                                                  _vm.data.type
                                                ],
                                              value: _vm.data.id,
                                            },
                                            on: { change: _vm.updateFile },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("ManageSidePanel", {
                ref: "manageSidePanel",
                attrs: {
                  "is-new": !_vm.data.id,
                  "created-at": _vm.data.createdAt,
                  "updated-at": _vm.data.updatedAt,
                  "published-at": _vm.data.publishedAt || "",
                  "is-loading": _vm.loading,
                  "entity-id": _vm.data.id,
                  "entity-type": "mediaLibrary",
                  language: _vm.language,
                  translations: _vm.fields.translations,
                },
                on: {
                  delete: function ($event) {
                    return _vm.$emit("delete-file")
                  },
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-media-library" })
                  },
                  submit: _vm.submit,
                  "update-translations": function ($event) {
                    return Object.assign(_vm.fields.translations, $event)
                  },
                  "language-update": function ($event) {
                    return _vm.$emit("language-update", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }